import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import Lottie from "lottie-react";
import successAnimation from "../../../assets/lottie/success.json"; // ✅ Checkmark animation
import errorAnimation from "../../../assets/lottie/error.json"; // ❌ Cross animation
import { primaryButtonStyles } from "../../../Styles/Styles";

const OfferStatusModal = ({ open, type, message, setStatusModal }) => {
  const handleCloseStatusModal = () => {
    setStatusModal({ open: false, type: "", message: "" });
  };
  return (
    <Dialog
      open={open}
      onClose={handleCloseStatusModal}
      aria-labelledby="ad-status-dialog"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Lottie
          animationData={type === "success" ? successAnimation : errorAnimation}
          style={{ width: 120, height: 120 }}
          loop={false}
        />
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "ClashGrotesk-Regular",
            textAlign: "center",
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          onClick={handleCloseStatusModal}
          variant="contained"
          sx={{ ...primaryButtonStyles }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OfferStatusModal;
